module.exports = __webpack_public_path__ + "static/media/hero-long.87341c0e.jpg";